import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'

const InstallPromptButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null)
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: Event) => {
            console.log('beforeinstallprompt fired')
            event.preventDefault()
            setDeferredPrompt(event)
            setShowButton(true)
        }

        const handleAppInstalled = () => {
            console.log('handleAppInstalled fired')
            setShowButton(false)
        }

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        window.addEventListener('appinstalled', handleAppInstalled)

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
            window.removeEventListener('appinstalled', handleAppInstalled)
        }
    }, [])

    const handleInstallClick = () => {
        console.log('handleInstallClick fired')

        if (deferredPrompt) {
            (deferredPrompt as any).prompt()
        }
    }

    const color: any = 'white'
    const show = showButton/* || true*/
    return (
        <>
            {show && <Button color={color} variant='outlined' onClick={handleInstallClick}>Install app on home screen</Button>}
        </>
    )
}


export default InstallPromptButton
